import React, { useContext } from "react"

import {
  SidebarContainer,
  PanelLink,
  ShowMoreLink,
  CloseButton,
  SectionHeading,
  SidebarLinkGroupWrapper,
  SidebarCategoryWrapper,
  SidebarCategoryOuterWrapper,
  SubcategoryHeadingLink,
  SubcategoryHeadingTitle,
} from "./sidebar.style"
import { UIContext } from "../layout"

import NavigationConfig, {
  INavbarCategory,
  INavbarSubcategory,
  INavbarLink,
  hasSubcategoryChildren,
} from "../../../navigation-config"

const SidebarLinkGroup = ({
  content,
  columns,
  gap,
}: {
  content: INavbarLink[]
  columns?: { sm: number; md: number }
  gap?: number
}) => {
  return (
    <SidebarLinkGroupWrapper
      columns={columns ?? { sm: 1, md: 1 }}
      $gap={gap ?? 12}
    >
      {content.map((link, idx) => (
        <PanelLink key={idx} to={link.path}>
          {link.icon && <img src={link.icon} alt="" />}
          {link.text}
        </PanelLink>
      ))}
    </SidebarLinkGroupWrapper>
  )
}

const SidebarSubcategoryRow = ({
  content,
}: {
  content: INavbarSubcategory
}) => {
  return (
    <div>
      {content.heading.path ? (
        <SubcategoryHeadingLink to={content.heading.path}>
          {content.heading.icon && <img src={content.heading.icon} alt="" />}
          {content.heading.text}
        </SubcategoryHeadingLink>
      ) : (
        <SubcategoryHeadingTitle>
          {content.heading.text}
        </SubcategoryHeadingTitle>
      )}
      <SidebarLinkGroup content={content.children} columns={{ sm: 1, md: 1 }} />
    </div>
  )
}

const SidebarCategory = ({ category }: { category: INavbarCategory }) => {
  const subcategoryView = hasSubcategoryChildren(category.children)

  return (
    <SidebarCategoryWrapper>
      <SectionHeading>{category.heading}</SectionHeading>
      {category.landingLink && (
        <SidebarCategoryOuterWrapper>
          <SubcategoryHeadingLink
            to={category.landingLink.path}
            style={{ marginBottom: "20px" }}
          >
            {category.landingLink.icon && (
              <img src={category.landingLink.icon} alt="" />
            )}
            {category.landingLink.text}
          </SubcategoryHeadingLink>
        </SidebarCategoryOuterWrapper>
      )}
      {subcategoryView ? (
        <SidebarCategoryOuterWrapper>
          {category.children.map((item, idx) => (
            <SidebarSubcategoryRow key={idx} content={item} />
          ))}
          {category.moreLinks && (
            <div>
              {category.moreLinks.map((link, idx) => (
                <ShowMoreLink to={link.path} key={idx}>
                  {link.icon && <img src={link.icon} alt="" />}
                  {link.text}
                </ShowMoreLink>
              ))}
            </div>
          )}
        </SidebarCategoryOuterWrapper>
      ) : (
        <SidebarLinkGroup
          content={category.children as INavbarLink[]}
          columns={category.columns}
          gap={category.gap}
        />
      )}
    </SidebarCategoryWrapper>
  )
}

export default function Sidebar() {
  const { state: UIState, dispatch: setUIState } = useContext(UIContext)

  return (
    <SidebarContainer isVisible={UIState.showSidebarNavigation}>
      <div>
        {NavigationConfig.map((category, idx) => (
          <SidebarCategory key={idx} category={category} />
        ))}
      </div>
      <CloseButton
        onClick={() =>
          setUIState((prevState) => ({
            ...prevState,
            showSidebarNavigation: !prevState.showSidebarNavigation,
          }))
        }
      />
    </SidebarContainer>
  )
}
